/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Change_Applied_A_To_BInputs */



/**
* | output |
* | --- |
* | "Change applied from Group A to Group B" |
*
* @param {Compare_Event_Groups_Change_Applied_A_To_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_change_applied_a_to_b = /** @type {((inputs?: Compare_Event_Groups_Change_Applied_A_To_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Change_Applied_A_To_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modification appliquée du groupe A au groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Änderung von Gruppe A auf Gruppe B angewendet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica applicata dal Gruppo A al Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменение внесено из группы А в группу В.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambio aplicado del Grupo A al Grupo B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从A组变更至B组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループAからグループBへの変更")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह A से समूह B में परिवर्तन लागू किया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alteração aplicada do Grupo A para o Grupo B")
	return /** @type {LocalizedString} */ ("Change applied from Group A to Group B")
});